import { SeoOptionsInterface } from '@wdpr/ra-angular-seo-metadata';
import { CookieService } from 'ngx-cookie-service';
import { GeolocationService } from '@wdpr/ra-angular-geolocation';
// Import LACD locales
import { registerLocaleData } from '@angular/common';
import es_AR from '@angular/common/locales/es-AR';
import es_CL from '@angular/common/locales/es-CL';
import es_CO from '@angular/common/locales/es-CO';
import es_MX from '@angular/common/locales/es-MX';
import es_PE from '@angular/common/locales/es-PE';
import pt_BR from '@angular/common/locales/pt';
// Import other countries locales
import en_CA from '@angular/common/locales/en-CA';
import fr_CA from '@angular/common/locales/fr-CA';
import en_GB from '@angular/common/locales/en-GB';
import en_EU from '@angular/common/locales/en-150';
import es_US from '@angular/common/locales/es-US';
import { AnimationService } from '@finder/shared/components/animations/animation-service/animation.service';
import { AuthenticationSvc } from '@finder/shared/services/authentication/authentication.service';
import { CONFIG_CONSTANTS } from '@finder/shared/constants/app.constants';
import { ConfigService } from '@finder/core/config.service';
import { ExplorerSvcConnectorService } from '@finder/shared/services/explorer-svc-connector/explorer-svc-connector.service';
import { FinderAnalyticsService } from '@finder/shared/services/finder-analytics/finder-analytics.service';
import { FinderApiConnectorService } from '@finder/shared/services/finder-api-connector/finder-api-connector.service';
import { FinderPersonalizationService } from '@finder/shared/services/finder-analytics/finder-personalization.service';
import { FinderThemeService } from '@finder/shared/services/theme-service/finder-theme.service';
import { LanguageBundleConnectorService } from '@finder/shared/services/language-bundle/language-bundle-connector.service';
import { lazyArrayToObj } from '@finder/shared/services/lazy-loader/lazy-bundles';
import { ListSvcConnectorService } from '@finder/shared/services/list-svc-connector/list-svc-connector.service';
import { LoadingService } from '@finder/shared/services/loading-service/loading-service.service';
import { LocaleHelperService } from '@finder/shared/services/locale-service/locale-helper.service';
import { LocaleService } from '@finder/shared/services/locale-service/locale-service.service';
import { MediaServiceConnectorService } from '@finder/shared/services/media-svc-connector/media-svc-connector.service';
// import { NativeBridgeInterceptor } from '@finder/shared/interceptors/native-bridge-interceptor/native-bridge-interceptor.service';
// import { NativeBridgeService } from '@finder/shared/services/native-bridge/native-bridge.service';
import { OneIdFactory } from '@finder/shared/services/one-id/one-id.factory';
import { ReservationServiceConnectorService } from '@finder/shared/services/reservation-svc-connector/reservation-svc-connector.service';
import { RouteStateService } from '@finder/shared/services/route-state-service/route-state-service';
import { SearchServiceConnectorService } from '@finder/shared/services/search-svc-connector/search-svc-connector.service';
import { TranslationHelperService } from '@finder/shared/interceptors/translation/translation-helper.service';
import { ViewportDetection } from '@finder/shared/services/viewport-detection/viewport-detection.service';
import { WebLinkValidationService } from '@finder/shared/services/web-link-validation/web-link-validation.service';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
// Register LACD countries locale metadata. Needed for Currency and Decimal pipes.
registerLocaleData(es_AR, 'es-ar');
registerLocaleData(es_CL, 'es-cl');
registerLocaleData(es_CO, 'es-co');
registerLocaleData(es_MX, 'es-mx');
registerLocaleData(es_PE, 'es-pe');
registerLocaleData(pt_BR, 'pt-br');
// Register other countries
registerLocaleData(en_CA, 'en_CA');
registerLocaleData(fr_CA, 'fr-ca');
registerLocaleData(en_GB, 'en_GB');
registerLocaleData(en_EU, 'en-eu');
registerLocaleData(es_US, 'es-us');
const APP_PROVIDERS = [
    AnimationService,
    AuthenticationSvc,
    CookieService,
    ExplorerSvcConnectorService,
    FinderAnalyticsService,
    FinderApiConnectorService,
    FinderPersonalizationService,
    FinderThemeService,
    GeolocationService,
    LanguageBundleConnectorService,
    ListSvcConnectorService,
    LoadingService,
    LocaleHelperService,
    LocaleService,
    MediaServiceConnectorService,
    // NativeBridgeService,
    ReservationServiceConnectorService,
    RouteStateService,
    SearchServiceConnectorService,
    TranslationHelperService,
    ViewportDetection,
    WebLinkValidationService,
    WindowRef,
];
const seoOptions = {
    useTranslate: false,
    serverPath: '/seo',
    manualBootstrap: true,
    includeMetaTag: {
        alternate: false,
    }
};
const ɵ0 = (config, auth) => () => {
    return config.load()
        .then((result) => {
        const baseUrl = config.getValue(CONFIG_CONSTANTS.apiUrlKey);
        const version = config.getValue(CONFIG_CONSTANTS.defaultVersionKey);
        const cdnList = config.getValue(CONFIG_CONSTANTS.cdnListKey);
        const cdnPath = config.getValue(CONFIG_CONSTANTS.cdnPathKey);
        // Set __webpack_public_path__ so the chunks js bundles
        // for lazy loading has the correct CDN domain.
        __webpack_public_path__ =
            (cdnList && cdnList.length > 0 ? cdnList[0] : '') + cdnPath;
        // ask for token early when the app initializes.
        auth.getAuthToken(version, baseUrl).subscribe();
        return Promise.resolve();
    })
        .catch((err) => {
        return err;
    });
}, ɵ1 = seoOptions, ɵ2 = (config) => {
    const webApiUrl = `${config.getValue('webApiUrl')}/${config.getValue('webApiDefaultVersion')}`;
    return {
        appTogglesName: 'appToggles',
        featureToggleUrl: webApiUrl + '/toggles',
    };
}, ɵ3 = [
    'siteId', 'path',
], ɵ4 = (finderAnalyticsService) => () => {
    return finderAnalyticsService.getP13nConfig();
}, ɵ5 = (finderAnalyticsService) => () => {
    return finderAnalyticsService.getDecisionAttributes();
}, ɵ6 = {
    configuration: {
        CEA: {
            decisionAttributesLoaderTimeout: 500,
        },
    },
}, ɵ7 = OneIdFactory, ɵ8 = lazyArrayToObj;
export class AppModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8 };
